






































import Vue from 'vue'
import { DAY_LABELS } from '@/product/const'
import { apolloClient } from '@/common/service/apolloClient'
import { deliveryDateQuery } from '@/product/queries'
import { paymentMethods } from '@/checkout/constants'
export default Vue.extend({
  name: 'DeliveryDateCalendar',
  props: {
    zipCode: {
      type: String,
      required: true
    }
  },
  data(): {
    orderDate: string
    conbiniDeliveryDate: string
    creditCardDeliveryDate: string
  } {
    return {
      orderDate: '',
      conbiniDeliveryDate: '',
      creditCardDeliveryDate: ''
    }
  },
  computed: {
    isMobile(): boolean {
      return window.innerWidth < 1024
    },
    dayLabels() {
      return DAY_LABELS
    },
    locale() {
      return {
        id: 'ja',
        masks: {
          title: 'YYYY年 M月'
        }
      }
    },
    attributes() {
      return [
        {
          dates: { weekdays: 1 },
          highlight: {
            contentClass: 'pr-Calendar_Sunday'
          }
        },
        {
          dates: new Date(this.conbiniDeliveryDate),
          highlight: {
            contentClass: this.conbiniDeliveryDate ? 'pr-Calendar_conbiniCardDeliveryDate' : ''
          }
        },
        {
          dates: new Date(this.creditCardDeliveryDate),
          highlight: {
            contentClass: this.creditCardDeliveryDate ? 'pr-Calendar_creditCardDeliveryDate' : ''
          }
        },
        {
          dates: new Date(this.orderDate),
          highlight: {
            contentClass: this.orderDate ? 'pr-Calendar_OrderDate' : ''
          }
        }
      ]
    },
    printableSkuId(): number {
      return this.$store.getters.estimate.printable_sku_id
    },
    quantity(): number {
      return this.$store.getters.estimate.quantity
    },
    today(): string {
      const date = new Date()
      return [date.getFullYear(),date.getMonth() + 1,date.getDate()].join('-')
    },
    trial(): boolean {
      return this.$store.getters.estimate.trial
    }
  },
  watch: {
    creditCardDeliveryDate(newValue, oldValue) {
      const oldDate = document.querySelector(`.id-${oldValue}`)
      const newDate = document.querySelector(`.id-${newValue}`)
      oldDate?.classList.remove('pr-Calendar_PriorityZIndex')
      newDate?.classList.add('pr-Calendar_PriorityZIndex')
    }
  },
  created() {
    this.orderDate = this.today
    this.getDeliveryDate()
  },
  methods: {
    onChangeOrderDate(day) {
      this.orderDate = day.id
      this.getDeliveryDate()
    },
    displayingCreditDeliveryDate(date: string) {
      const currentMonth = Number(date.split('-')[1])
      const calendarEl = this.$refs.calendar as HTMLElement
      const visibleMonth = calendarEl.pages.map(pages => pages.month)
      if (!visibleMonth.includes(currentMonth))
        calendarEl.move(1)
    },
    async getDeliveryDate() {
      await apolloClient
        .query({
          query: deliveryDateQuery,
          variables: {
            printableSkuId: this.printableSkuId,
            zipCode: this.zipCode,
            quantity: this.quantity,
            orderDate: this.orderDate,
            trial: this.trial
          }
        })
        .then(response => {
          const data = response.data.deliveryDates
          if (data) {
            const creditCardDeliveryDate = data.find(deliveryDate => deliveryDate.paymentMethod === paymentMethods.creditcard).date.value
            const conbiniDeliveryDate = data.find(deliveryDate => deliveryDate.paymentMethod === paymentMethods.convenienceStore).date.value
            if (creditCardDeliveryDate) {
              this.displayingCreditDeliveryDate(creditCardDeliveryDate)
              this.creditCardDeliveryDate = creditCardDeliveryDate
              this.conbiniDeliveryDate = conbiniDeliveryDate
            }
          }
        })
        .catch(error=>{
          throw Error(error)
        })
    }
  }
})
